<script lang="ts">
    import Icon from "@components/material/Icon.svelte"
    import ContextMenu from "@components/utilities/context-menu/ContextMenu.svelte"
    import ContextMenuEffect from "@components/utilities/context-menu/ContextMenuEffect.svelte"
    import { clickEnter } from "@utils/directives/accessibility"
    import { canShare } from "@utils/reading/copy"
    import { CAN_DOWNLOAD } from "@utils/share/download"
    import { resultify } from "@utils/utilities/effect/result"
    import { Effect } from "effect"

    /**
     * External override
     */
    export let enabled = true
    let showContextMenu = false
    export let download: Effect.Effect<unknown, unknown, never>
    export let share: Effect.Effect<unknown, unknown, never>

    const calculateSingleAction = (canDownload: boolean, canShare: boolean) => {
        if (canShare && canDownload) return undefined
        if (canShare) return share
        if (canDownload) return download
        return undefined
    }
    $: console.log({ enabled })
    $: singleAction = share && download && calculateSingleAction(CAN_DOWNLOAD, !!$canShare)
    let internalDisabled = false
    $: disabled = internalDisabled || !enabled
</script>

<div
    on:keydown={clickEnter}
    tabindex="0"
    role="button"
    aria-disabled={disabled}
    aria-haspopup={singleAction ? "false" : "menu"}
    aria-label={singleAction ? "Share" : "Share Dropdown"}
    aria-expanded={singleAction ? undefined : showContextMenu}
    on:click={() => {
        if (disabled) return
        if (singleAction) {
            internalDisabled = true
            resultify(singleAction, { toast: true }).then(() => (internalDisabled = false))
        } else {
            showContextMenu = true
        }
    }}
    class="absolute z-2 aria-disabled:grayscale transition-all -right-1 -top-1 h-10 w-10 bg-white dark:bg-black p-2 rounded-full flex items-center justify-center"
>
    <Icon
        icon={singleAction ? (singleAction === share ? "share" : "download") : "popout"}
        class="w-4 {disabled
            ? 'opacity-50'
            : ''}  transition-all h-4 text-blue-900 dark:text-blue-100"
    />
    {#if showContextMenu}
        <ContextMenu
            positions={["bl"]}
            on:exit={() => {
                showContextMenu = false
            }}
        >
            {#if $canShare}
                <ContextMenuEffect icon="share" effect={share}>Share</ContextMenuEffect>
            {/if}
            {#if CAN_DOWNLOAD}
                <ContextMenuEffect icon="download" effect={download}>Save</ContextMenuEffect>
            {/if}
        </ContextMenu>
    {/if}
</div>
